import { dateFormat } from 'src/utils/DateHelper';
import { responseDataType } from './const';
import { shortNumberNotationStartingWithLakhs } from '@cp/src/utils/commonUtils';
import { ICashCollectedBreakup } from '@cp/src/reducers/leaderboardSlice';

export const getFirstDate = (type: 'curr' | 'prev') => {
  const date = new Date();
  const year = date.getFullYear();
  const month = date.getMonth();
  if (type === 'curr') {
    return dateFormat(new Date(year, month, 1), 'DD');
  }
  // case for January
  if (month == 0) return dateFormat(new Date(year, 11, 1), 'DD');
  return dateFormat(new Date(year, month, 1), 'DD');
};

export const getLastDate = (type: 'curr' | 'prev') => {
  const date = new Date();
  const year = date.getFullYear();
  const month = date.getMonth();
  if (type === 'curr') {
    return dateFormat(date, 'DD MMM YYYY');
  }
  // case for January
  if (month == 0) return dateFormat(new Date(year, 11, 0), 'DD MMM YYYY');
  return dateFormat(new Date(year, month, 0), 'DD MMM YYYY');
};

export const getMonth = (type: 'curr' | 'prev') => {
  const current = new Date();
  if (type == 'curr') {
    current.setMonth(current.getMonth() - 1);
    return dateFormat(current, 'MMM YYYY');
  }
  return dateFormat(current, 'MMM YYYY');
};

export const transformData = (responseData: ICashCollectedBreakup) => {
  return {
    name: responseData.label,
    y: responseData.value,
    value: shortNumberNotationStartingWithLakhs(responseData.value, 1, ' '),
    color: responseData.fill
  };
};
